/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function IntroWithThreeColumnsIcons({ data, id, dir }) {
  return (
    <section style={data.backgroundColor} id={id} dir={dir}>
      <div
        className="container max-w-[1200px] mx-auto px-6 
      pt-[50px] md:pt-[70px] lg:pt-[100px] pb-[25px] lg:pb-[50px]">
        <div className="max-w-[570px] text-center mx-auto pb-5">
          <h2 className="text-clamp22to30 mb-4">{data.title}</h2>
          <div className='font-DINRegular' dangerouslySetInnerHTML={{ __html: data.text }} />
        </div>
        {data.items && (
          <div className="grid md:grid-cols-3 gap-8 md:gap-10 lg:gap-14">
            {data.items.map(({ content: { title, text, icon }, index }) => (
              <div key={index} className="font-DINRegular flex flex-col items-center
              md:items-start">
                {!isEmpty(icon) && (
                  <div
                    className="w-[166px] h-[86px] border-b-2 border-b-[#347CD9] pb-[22px]
                  mb-4 flex items-end justify-center md:justify-start">
                    <LazyLoadImage src={icon.url} className="align-bottom" />
                  </div>
                )}
                <h2 className="text-clamp20to40 text-[#4A4A4A] mb-3 ltr:md:text-left
                rtl:md:text-right text-center">{title}</h2>
                <div
                  className="text-[#898989] font-DINRegular ltr:md:text-left rtl:md:text-right
                  text-center"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
